import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { RootState } from '../../reducers';
import * as actions from '../../actions/generalActions';
import { withRouter } from 'react-router';
import './Installation.scss'
import * as productionActions from '../../actions/production'
import * as installationActions from '../../actions/installation'
import TableBbros from '../../components/Table/TableBbros';
import {
    INSTALLATION_RECORDS_COLUMNS,
    INSTALLATION_RECORDS_COLUMNS_MOBILE,
    OPTIONS
} from '../../components/Table/TableConstants';
import EditIcon from '@material-ui/icons/Edit';
import * as transportActions from "../../actions/transport";
import DeleteIcon from "@material-ui/icons/DeleteOutline";
import DeleteModalComponent from "../../components/Modal/DeleteModal";
import ModalComponent from "../../components/Modal/ModalComponent";
import {isMobile, TRANSPORT_STATUSES} from "../../constants/constants";
import TranslatedText, {translatedText} from "../../components/TranslatedText";
import {useParams} from "react-router-dom";
import {ParameterTypes} from "../../types/parameter.type";
import MikaSelect from "../../components/BbrosSelect/mikaSelect.component";
import moment from "moment";
import DifferentColoredPlus from "../../assets/icons/differentColoredPlus.svg";
import {Button, EButtonType} from "../../components/Button";
import {toast} from "react-toastify";
import {SelectOption} from "../../types/selectOption.type";
import FontAwesome from 'react-fontawesome';
import PaginationComponent from '../../components/Pagination/PaginationComponent';
import '../../components/Pagination/Pagination.scss';
import SearchBar from '../../components/SearchBar/SearchBar';
import DatePicker from 'react-datepicker';


interface Props {
    intl: any;
    loading: boolean;
    setLoading: boolean;
    history: any;
    production: any,
    productionActions: any
    actions:any;
    letter: string;
    clientsByModuleData: any;
    transportActions: any
    transport: any
    archiveRecords: any
    installationActions: any
    installation: any,
    buttonLoader: any,
    permissions: any
}

const AllInstallationRecords = (props: Props) => {
    const {query} = useParams <ParameterTypes>()

    const [installationRecordId, setInstallationRecordId] = useState<number>(null)
    const [isDeleteModalOpen, setDeleteModal] = useState<boolean>(false);
    const [selectedStatus, setSelectedStatus] = useState<SelectOption>({} as SelectOption)
    const [startDate, setStartDate] = useState<any>()
    const [endDate, setEndDate] = useState<any>()
    const [filtersOpened, setFiltersOpened] = useState<boolean>(false)
    const [calculatedTotalPrice, setCalculatedTotalPrice] = useState<number>(0)
    const [currentPage, setCurrentPage] = useState<number>(1)
    const [perPage, setPerPage] = useState<number>(20)
    const [searchTerm, setSearchTerm] = useState<string>('')


    useEffect(() => {
        props.installationActions.getInstallationRecords(query, null, null, currentPage, perPage)
    }, [query, currentPage, perPage])

    function getClients(){
        props.installationActions.getInstallationRecords(query, startDate, endDate, currentPage, perPage)
    }

    const editInstallationData = (transportRecord) => {
        props.history.push({pathname: `/dashboard/installation/create/${transportRecord?.id}`})
    }

    const handleRemove = (installationRecord) => {
        setDeleteModal(true)
        setInstallationRecordId(installationRecord?.id)
    }

    const deleteInstallation = () => {
        props.transportActions.deleteTransportRecord(installationRecordId).then(()=>{
            props.installationActions.getInstallationRecords()
        })
        setDeleteModal(false)
    }

    const actions = [
        {
            icon: EditIcon,
            tooltip: 'Edit',
            onClick: (event, rowData) => editInstallationData(rowData)
        },
        {
            icon: DeleteIcon,
            tooltip: 'Delete',
            onClick: (event: Event, rowData) => handleRemove(rowData)
        }
    ]

    function filterData(){
        setCurrentPage(1)
        if(selectedStatus?.value || (startDate && endDate)){
            getClients()
            setFiltersOpened(false)
        }else{
            if(!selectedStatus?.value){
                getClients()
                setFiltersOpened(false)
                return
            }
            getClients()

        }
    }

    const handlePageChange = (page: number) => {
        setCurrentPage(page)
    }

    const handlePerPageChange = (value: number) => {
        setPerPage(value)
        setCurrentPage(1)
    }

    const handleSearch = (term: string) => {
        setSearchTerm(term)
        setCurrentPage(1)
        props.installationActions.getInstallationRecords(query, startDate, endDate, 1, perPage, term)
    }

    const handleClearSearch = () => {
        setSearchTerm('')
        setCurrentPage(1)
        props.installationActions.getInstallationRecords(query, startDate, endDate, 1, perPage, '')
    }

    useEffect(() => {
        // Use grand total from backend (all records) instead of local calculation (paginated only)
        setCalculatedTotalPrice(Number(props?.installation?.installationRecordsGrandTotal) || 0)
    }, [props?.installation?.installationRecordsGrandTotal]);

    return(
        <div className="wrapper production-module-container warehouseContainer">
            <div className="table-scroll-container">
                <TableBbros
                    className={'hide-material-table-pagination'}
                    title={translatedText({id: "table.warehouse", defaultMessage: "Instalimi"})}
                    data={props?.installation?.installationRecords}
                    columns={INSTALLATION_RECORDS_COLUMNS}
                    options={{...OPTIONS, paging: false, search: false}}
                    actions={actions}
                    isLoading={props.loading}
                    toolbarContent={
                        <>
                            <div className={'totalPriceContainerForProduction'}>
                                <p><TranslatedText id="total" defaultMessage="Totali: "/></p>
                                <p>{calculatedTotalPrice?.toFixed(2)} €</p>
                            </div>
                            <div className="module-search-container">
                                <SearchBar
                                    placeholder={translatedText({id: "search.installation", defaultMessage: "Kërko instalime..."})}
                                    onSearch={handleSearch}
                                    onClear={handleClearSearch}
                                    isLoading={props?.loading}
                                    value={searchTerm}
                                />
                            </div>
                            <div className={'filter-icon-container'}>
                                <div className={'filter-icon'} onClick={() => setFiltersOpened(!filtersOpened)}>
                                    <FontAwesome name={'filter'}/>
                                </div>
                                <div className={`filter-dropdown ${filtersOpened ? 'show' : 'hide'}`} onClick={(e) => e.stopPropagation()}>
                                    <div className={'filterWrapper'}>
                                        <div className={'closeFiltersButton'} onClick={() => setFiltersOpened(!filtersOpened)}>
                                            <FontAwesome name={'close'}/>
                                        </div>
                                        {!query && <MikaSelect options={TRANSPORT_STATUSES} placeholder={'Statusi'} value={selectedStatus}
                                                                  setEntireOptionFunction={setSelectedStatus}/>}
                                        <div className={`dateContainer`}>
                                            <p className={'label'}>Data e fillimit</p>
                                            {startDate && <img src={DifferentColoredPlus} onClick={() => setStartDate('')}
                                                               className="x-signDate" alt="clear"/>}
                                            <div className={'calendar'}>
                                                <DatePicker
                                                    selected={startDate ? new Date(startDate) : null}
                                                    onChange={(date: Date) => setStartDate(date ? moment(date).format('YYYY-MM-DD') : '')}
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Zgjidh datën"
                                                    className="date-picker-input"
                                                    popperPlacement="bottom-start"
                                                />
                                            </div>
                                        </div>
                                        <div className={`dateContainer`}>
                                            <p className={'label'}>Data e mbarimit</p>
                                            {endDate &&
                                            <img src={DifferentColoredPlus} onClick={() => setEndDate('')} className="x-signDate" alt="clear"/>}
                                            <div className={'calendar'}>
                                                <DatePicker
                                                    selected={endDate ? new Date(endDate) : null}
                                                    onChange={(date: Date) => setEndDate(date ? moment(date).format('YYYY-MM-DD') : '')}
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Zgjidh datën"
                                                    className="date-picker-input"
                                                    popperPlacement="bottom-start"
                                                />
                                            </div>
                                        </div>
                                        <Button
                                            isLoading={props?.buttonLoader}
                                            isDisabled={props?.buttonLoader}
                                            className="m-auto w-100"
                                            onClick={filterData}
                                            buttonType={EButtonType.GreyButton}>
                                            Filtro
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <div className={'toolbar-export-button'} onClick={() => {
                                const csvContent = [
                                    INSTALLATION_RECORDS_COLUMNS.map((col: any) => col.title).join(','),
                                    ...props?.installation?.installationRecords?.map((row: any) =>
                                        INSTALLATION_RECORDS_COLUMNS.map((col: any) => {
                                            const value = row[col.field] || '';
                                            return `"${String(value).replace(/"/g, '""')}"`;
                                        }).join(',')
                                    )
                                ].join('\n');
                                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                                const link = document.createElement('a');
                                link.href = URL.createObjectURL(blob);
                                link.download = 'instalime.csv';
                                link.click();
                            }}>
                                <FontAwesome name="download" />
                            </div>
                        </>
                    }
                />
            </div>
            <PaginationComponent
                currentPage={currentPage}
                perPage={perPage}
                pagination={props.installation?.installationRecordsPagination}
                onPageChange={handlePageChange}
                onPerPageChange={handlePerPageChange}
                label="instalime"
            />
            <ModalComponent
                isModalHeader
                isOpen={isDeleteModalOpen}
                close={setDeleteModal}
            >
                <DeleteModalComponent
                    history={props.history}
                    close={() => setDeleteModal(false)}
                    deleteFunction={() => deleteInstallation()} />
            </ModalComponent>
        </div>
    )
}

function mapGlobalStateToProps(state: RootState, ownProps: any) {
    return {
        ...ownProps,
        ...state.app,
        production: state.production,
        transport: state.transport,
        installation: state.installation
    }
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
    return {
        productionActions: bindActionCreators(productionActions as any, dispatch),
        actions: bindActionCreators(actions as any, dispatch),
        transportActions: bindActionCreators(transportActions as any, dispatch),
        installationActions: bindActionCreators(installationActions as any, dispatch),
    }
}

export default withRouter(connect(mapGlobalStateToProps, mapDispatchToProps)(injectIntl(AllInstallationRecords as any)));